module.exports = __webpack_public_path__ + "img/e52d712cd8f21a1e0568136772813867.png";